<template>
  <div class="classContainer">
    <van-nav-bar
      title="课表进度表"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="classSchedule">
      <div class="teachingInfo">
        <van-cell-group inset>
          <van-cell title="名称：" :value="teachPlanDetailData.planName" />
          <van-cell title="内容：" :value="teachPlanDetailData.lessonContent" />
          <van-cell title="授课：" :value="teachPlanDetailData.teacherName" />
          <van-cell title="对象：" :value="teachPlanDetailData.classNames" />
          <van-cell>
            <template slot="title">
              <span class="font-size0 van-color-text-assist">人数：</span>
            </template>
            <template>
              <span class="font-size2 van-color-warning bold"
                >{{ teachPlanDetailData.listenNumber
                }}<i
                  class="clickPeo"
                  v-if="queryType == '1'"
                  @click="checkStudentPeo"
                  >点击查看学员</i
                ></span
              >
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="teachDes" v-if="teachPlanDetailData.addressName">
        <p class="title">上课地点</p>
<!--        <p class="dsc">上课时间：{{ teachPlanDetailData.classTime }}</p>-->
        <p class="dsc">{{ teachPlanDetailData.addressName }}</p>
      </div>
      <div class="teachDes" v-if="caseList.length>0">
        <p class="title">课程教案</p>
        <ResourceList :resources="caseList" />
      </div>
      <div class="teachDes" v-if="materialList.length>0">
        <p class="title">教学资料</p>
        <ResourceList :resources="materialList" />
        <!--        <table>
          <thead>
          <tr>
            <th>周次</th>
            <th>日/星期</th>
            <th>课程内容</th>
            <th>节次</th>
            <th>教师</th>
            <th>课件</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in detailList">
            <td>{{ item.weekNum?item.weekNum:'-' }}</td>
            <td>{{ item.teachingDate }}{{item.teachWeekName }}</td>
            <td>{{item.content }}</td>
            <td>{{ item.periods }}</td>
            <td>{{ item.teacherNames }}</td>
            <td style="color: #3776FF;" @click="openPdf(item.fileUrl)">{{item.fileUrl?'查看':'-'}}</td>
          </tr>
          </tbody>
        </table>
        <p class="sign">讲课负责教师<span class="value">____________________________</span></p>
        <p class="sign">教研室主任<span class="value">______________________________</span></p>
        <p class="sign right">签名（<span class="value">__________</span>月<span class="value">__________</span>日）</p>
        <p class="sign">实验见习负责教师<span class="value">_________________________</span></p>
        <p class="sign">教育科主任<span class="value">______________________________</span></p>
        <p class="sign right">审核（<span class="value">__________</span>月<span class="value">__________</span>日）</p>
        <p class="sign">医院<span class="value">___________________________________</span></p>
        <p class="sign right">审核（<span class="value">__________</span>月<span class="value">__________</span>日）</p>
        <p class="remark">
          1、此表务请逐项填写，讲课、实习内容必须具体实习如需放录象、电影、用显微镜以及其它条件,应在备注栏内注明,以便统筹安排。<br/><br/>
          2、填制一式三份在规定时间内交教育科审核后,一份交医学院，一份留教育科并向学生公布，一份留教研室。
        </p>-->
      </div>
      <div class="teachDes" v-if="teachPlanDetailData.paperStatus == '1'">
        <p class="title">课堂小测</p>
        <div v-for="item in paperList">
          <div class="homework">
            <p class="contentTi">内容：{{ item.name }}</p>
            <p
              class="btnCli"
              v-if="queryType == '1'"
              @click="checkStudentRa(item, 'paper')"
            >
              查看
            </p>
            <div v-else>
              <p class="btnCli disabled" v-if="teachPlanDetailData.timeStatus == 0">
                开始作业
              </p>
              <p class="btnCli" v-if="teachPlanDetailData.timeStatus == 1" @click="startQuestions(item)">
                {{ item.paperStatus == "1" ? "已完成" : "开始作业" }}
              </p>
              <p class="btnCli" v-if="teachPlanDetailData.timeStatus == 2" @click="startQuestions(item)">
                {{ item.paperStatus == "1" ? "已完成" : "未考试" }}
              </p>
            </div>

          </div>
          <p class="contentTi" v-if="queryType == '1'">
            完成情况：{{ item.paperFinishCount }}/{{ item.paperTotalCount }}
          </p>
        </div>
      </div>
      <div
        class="teachDes"
        v-if="
          teachPlanDetailData.ratingCriteriaStatus != null && teachPlanDetailData.ratingCriteriaStatus != '0' && queryType == '1'
        "
      >
        <p class="title">课堂评分</p>
        <div v-for="item in ratingCriteriaList">
          <div class="homework">
            <p class="contentTi">内容：{{ item.name }}</p>
            <p class="btnCli" v-if="teachPlanDetailData.timeStatus != 0" @click="checkStudentRa(item, 'rating')">查看</p>
          </div>
          <p class="contentTi">
            完成情况：{{ item.ratingCriteriaFinishCount }}/{{
              item.ratingCriteriaTotalCount
            }}
          </p>
        </div>
      </div>
      <div class="teachDes" v-if="teachPlanDetailData.homeworkStatus == '1' && queryType != '1'">
        <p class="title">作业任务</p>
        <div v-for="item in homeworkList">
          <div class="homework">
            <p class="contentTi">内容：{{ item.homeworkContent }}</p>
            <p
              class="btnCli"
            >
              {{ item.homeworkStatus == 1?'已完成':'未完成' }}
            </p>

          </div>
          <p class="contentTi">
           请前往电脑端进行上传
          </p>
          <ResourceList :resources="homeworkAttachList" />
          <p class="contentTi">发布时间：
            <span v-if="teachPlanDetailData.homeworkStartTime && teachPlanDetailData.homeworkEndTime">
            {{teachPlanDetailData.homeworkStartTime}}~{{teachPlanDetailData.homeworkEndTime}}
          </span>
          </p>
        </div>
      </div>
      <div
        class="teachDes"
        v-if="
          teachPlanDetailData.homeworkStatus == '1' && queryType == '1'
        "
      >
        <p class="title">作业布置</p>
        <div v-for="item in homeworkList">
          <div class="homework">
            <p class="contentTi">内容：{{ item.homeworkContent }}</p>
            <p class="btnCli" @click="checkHomework">查看</p>
          </div>

          <p class="contentTi">
            完成情况：{{ item.homeworkFinishCount }}/{{
              item.homeworkTotalCount
            }}
          </p>
          <ResourceList :resources="homeworkAttachList" />
          <p class="contentTi">发布时间：
            <span v-if="teachPlanDetailData.homeworkStartTime && teachPlanDetailData.homeworkEndTime">
            {{teachPlanDetailData.homeworkStartTime}}~{{teachPlanDetailData.homeworkEndTime}}
          </span>
          </p>
        </div>

      </div>
      <div class="teachDes">
        <p class="title">
          评价建议
          <span
            v-if="queryType == '1'"
            @click="checkNotice"
            class="btnCli"
          >
            查看
          </span>
          <template v-else>
            <span
              v-if="teachPlanDetailData.suggest == '' || teachPlanDetailData.suggest == null"
              @click="addNotice"
              class="btnCli"
            >
            添加
          </span>
          </template>


        </p>
        <p class="contentTi" v-if="teachPlanDetailData.suggest">
          {{ teachPlanDetailData.suggest }}
        </p>
      </div>
    </div>
    <div v-if="queryType != '1'">
      <p
        class="attendancePunch"
        @click="signClock"
        v-if="teachPlanDetailData.attendanceStatus == '1' && teachPlanDetailData.timeStatus != 0"
      >
        考勤打卡
      </p>
      <p
        class="attendancePunch disabled"
        v-else
      >
        考勤打卡
      </p>
    </div>

    <van-dialog v-model="showNotice" title="评价建议" show-cancel-button confirmButtonColor="#3776ff" @confirm="confirmNotice">
      <van-field
        class="noteTextarea"
        v-model="suggest"
        rows="3"
        type="textarea"
        maxlength="200"
        show-word-limit
        placeholder="请输入评价建议"
      />
    </van-dialog>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import ResourceList from "@/components/ResourceList.vue";
import {
  studentSaveCriteria,
  teachingPlanDetailProcess,teachingPlanDetailSuggestSave
} from "@/api/classSchedule";
import checkStudent from "@/views/classSchedule/checkStudent.vue";
import { Message } from "element-ui";
export default {
  name: "teachProcess",
  components: { ResourceList },
  computed: {
    checkStudent() {
      return checkStudent;
    },
  },
  data() {
    return {
      planDetailId: "",
      teachPlanDetailData: {},
      materialList: [],
      caseList:[],
      paperList: [],
      ratingCriteriaList: [],
      queryType: "0", //0学员，1老师
      homeworkList:[],
      homeworkAttachList:[],
      showNotice: false,
      suggest:''
    };
  },
  methods: {
    onClickLeft() {
      console.log("????????????",this.$route.query.weekday);
      if( this.$route.query.weekday ){
         this.$router.push(
          "/classSchedule?weekday=" +
            this.$route.query.weekday +
            "&yearWeekDateStr=" +
            this.$route.query.yearWeekDateStr +
            "&weekName=" +
            this.$route.query.weekName +
            "&queryType=" +
            this.$route.query.queryType
        );

      }else{
        if( localStorage.getItem("source")){
          wx.miniProgram.postMessage({
            data: {
              action:"back",
              title: 'ceshi'
            }
          })
          wx.miniProgram.navigateBack()

        }else{

          if (this.judgeClient() == "Android") {
            this.closeAndroid();
          } else {
            this.closeIos();
          }
        }
      }

    },
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {
        }
      );
    },
    closeIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    //考勤打卡
    signClock() {
      this.$router.push(
        "/clocking?planDetailId=" + this.teachPlanDetailData.planDetailId
      );
    },
    //获取教学计划详情
    async getTeachPlanDetail() {
      let res = await teachingPlanDetailProcess(this.planDetailId,{queryType:this.queryType});
      this.teachPlanDetailData = res.data;
      //教学资料
      this.materialList = res.data.materialList ? res.data.materialList : [];
      this.caseList = res.data.caseList ? res.data.caseList : [];
      //试卷
      this.paperList = res.data.paperList ? res.data.paperList : [];
      //评价学员
      this.ratingCriteriaList = res.data.ratingCriteriaList
        ? res.data.ratingCriteriaList
        : [];
      //作业布置
      this.homeworkList = res.data.homeworkList
        ? res.data.homeworkList
        : [];
      //作业布置附件
      this.homeworkAttachList = res.data.homeworkAttachList
        ? res.data.homeworkAttachList
        : [];
    },
    //查看学生评价
    checkStudentRa(item, operationType) {
      this.$router.push(
        "/checkStudentEvaluate?planDetailId=" +
          item.planDetailId +
          "&operationType=" +
          operationType +
          "&ratingCriteriaId=" +
          item.ratingCriteriaId +
          "&ratingCriteriaStatus=" +
          this.teachPlanDetailData.ratingCriteriaStatus +
          "&paperId=" +
          item.paperId
      );
    },
    //查看学生作业
    checkHomework() {
      this.$router.push(
        "/checkStudentHomework?planDetailId=" + this.planDetailId
      );
    },
    //查看学生人数
    checkStudentPeo(item) {
      console.log('this.teachPlanDetailData',this.teachPlanDetailData)
      this.$router.push("/checkStudent?planId=" + this.teachPlanDetailData.planId+'&planDetailId='+this.planDetailId);
    },
    //开始答题
    async startQuestions(item) {
      //timeStatus 1进行中 2已结束
      //paperStatus 0未开始 1已完成
      if(this.teachPlanDetailData.timeStatus == 1){
        if (item.paperStatus != 1) {
          this.$router.push({
            path: "/courseTopic",
            query: {
              type: 2,
              queryType: this.queryType,
              paperStatus: item.paperStatus,
              paperId: item.paperId,
              planDetailId: item.planDetailId,
            },
          });
        } else {
          this.$router.push({
            path: "/scoreReport",
            query: {
              type: 2,
              queryType: this.queryType,
              paperStatus: item.paperStatus,
              paperId: item.paperId,
              planDetailId: item.planDetailId,
            },
          });
        }
      }else {
        if(item.paperStatus == 1){
          this.$router.push({
            path: "/scoreReport",
            query: {
              type: 2,
              queryType: this.queryType,
              paperStatus: item.paperStatus,
              paperId: item.paperId,
              planDetailId: item.planDetailId,
            },
          });
        }
      }

      // if(item.paperStatus == '1'){
      //   return;
      // }
      // let params = {
      //   paperId:item.paperId,
      //   planDetailId:item.planDetailId,
      // }
      // let res = await studentSaveCriteria(params);
      // Message.success('开始答题成功')
      // this.getTeachPlanDetail()
    },
    openPdf(fileUrl) {
      if (fileUrl) {
        location.href = this.imgUrl + fileUrl;
        // this.$router.push('/checkPdf?fileUrl='+fileUrl)
      }
      // this.$router.push('/checkPdf?fileUrl=static/20250313/b0167baa-21fd-4f28-81a6-e46812c94200.pdf')
    },
    //学生端增加评价建议
    addNotice(){
      this.suggest = ''
      this.showNotice = true;
    },
    async confirmNotice(){
      if(this.suggest){
        let params = {
          planDetailId: this.planDetailId,
          suggest: this.suggest,
        }
        let res = await teachingPlanDetailSuggestSave(params);
        this.$message({
          type: "success",
          message: "保存成功！",
        });
        this.getTeachPlanDetail()
      }else{
        this.$message.warning('请输入评价建议')
      }
    },
    //老师端查看评价建议
    checkNotice(){
      this.$router.push(
        "/checkStudentNotice?planDetailId="+this.planDetailId
      );
    }
  },
  mounted() {
    this.planDetailId = this.$route.query.planDetailId;
    this.queryType = this.$route.query.queryType;
    this.getTeachPlanDetail();
  },
};
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon {
  color: #2f2f46;
}
::v-deep .van-cell-group--inset {
  margin: 0;
  padding-top: 15px;
  border-radius: 12px;
}
::v-deep .van-cell {
  font-weight: 400;
  font-size: 14px;
  color: #2f2f46;
}
::v-deep .van-cell__value {
  color: #7a7c8b;
  .clickPeo {
    margin-left: 5px;
    font-style: normal;
    color: #3776ff;
  }
}
.classContainer {
  .classSchedule {
    height: calc(100vh - 46px);
    background: #f5f5f5;
    padding: 12px 16px 50px 16px;
    overflow-y: auto;
  }
  .attendancePunch {
    position: fixed;
    bottom: 5px;
    left: 7%;
    width: 85%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #3776ff;
    box-shadow: 0 3px 10px 0 rgba(55, 118, 255, 0.3);
    border-radius: 16px;
    color: #ffffff;
    font-size: 12px;
  }
  .disabled{
    background: #eeeeee;
    color: #7a7c8b;
    box-shadow: none;
  }
  .teachDes {
    margin-top: 12px;
    padding: 19px 13px 15px 16px;
    background: #ffffff;
    border-radius: 12px;
    .title {
      font-weight: 600;
      font-size: 17px;
      color: #2f2f46;
      margin-bottom: 10px;
      .btnCli {
        float: right;
        display: inline-block;
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #3776ff;
        box-shadow: 0 3px 10px 0 rgba(55, 118, 255, 0.3);
        border-radius: 16px;
        color: #ffffff;
        font-size: 12px;
      }
    }
    .dsc {
      margin-top: 10px;
      font-size: 14px;
      color: #7a7c8b;
      line-height: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eeeeee;
    }
    .dsc:last-child {
      border-bottom: none;
    }
    .contentTi {
      font-size: 14px;
      color: #7a7c8b;
      width: calc(100% - 85px);
    }
    .homework {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btnCli {
        display: inline-block;
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #3776ff;
        box-shadow: 0 3px 10px 0 rgba(55, 118, 255, 0.3);
        border-radius: 16px;
        color: #ffffff;
        font-size: 12px;
      }
      .disabled{
        background: #eeeeee;
        color: #7a7c8b;
        box-shadow: none;
      }
    }
    table {
      width: 100%; /* 表格宽度 */
      border-collapse: collapse; /* 合并边框 */
      border: 1px solid #eeeeee; /* 外边框 */
      font-family: Arial, sans-serif;
      table-layout: fixed;
    }

    /* 表头样式 */
    th {
      border: 1px solid #eeeeee; /* 内边框 */
      padding: 10px; /* 内边距 */
      text-align: center; /* 文字对齐 */
      font-weight: 400;
      font-size: 14px;
      color: #2f2f46;
    }

    /* 表格单元格样式 */
    td {
      //width: 24%;
      border: 1px solid #eeeeee; /* 内边框 */
      padding: 8px; /* 内边距 */
      text-align: center; /* 文字对齐 */
      font-weight: 400;
      font-size: 12px;
      color: #2f2f46;
      word-break: break-word;
    }
    .sign {
      margin-top: 15px;
      font-weight: 400;
      font-size: 14px;
      color: #2f2f46;
      .value {
        color: #eeeeee;
        margin-left: 5px;
      }
    }
    .right {
      text-align: right;
    }
    .remark {
      margin-top: 25px;
      font-size: 14px;
      color: #8f91a1;
      line-height: 20px;
    }
  }
}
</style>
